import React from 'react'

// Lazy loading
import loadable from '@loadable/component'

interface ImageShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Image
  location?: any
}

interface PostProps {
  [key: string]: any
}

const ImageShell: React.FC<ImageShellProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    shadow_image: loadable(() => import('components/flex/Image/ShadowImage')),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default ImageShell
